
import React, { useEffect } from "react";
import { useState } from "react";
import { GetappointmentsbyPut, Updateappointmentstatus } from "../../api/helper";
import { useSelector } from "react-redux";

const TodayAppointments = () => {
      const profileData = useSelector((state) => state?.cookies?.userDetails);

      const [appointments, setAppointments] = useState([]);
    

 const FetchAppointment = async (page = 1) => {
    const data = {
      doctorId: profileData?._id,
      page,
      limit: 50,
      status: "Accepted",
    };
    try {
      const respo = await GetappointmentsbyPut(data);
      console.log(respo?.data?.data?.appointments, "respo---");
      setAppointments(respo?.data?.data?.appointments);
    } catch (error) {
      console.log(error, "error---");
    }
  };
  useEffect(() => {
    FetchAppointment();
  }, []);

  return (
    <div className="appointments-table-container">
      <table className="appointments-table">
        <thead>
          <tr>
            <th>ID</th>
        
            <th>Client Name</th>
            <th>Provider</th>
            <th>Payment Mode</th>
            <th>Appointment Status</th>
            <th>Date & Time</th>
            {/* <th>Actions</th> */}
          </tr>
        </thead>
     <tbody>
   {appointments?.length > 0 ? (
    appointments.map((appointment, index) => (
      <tr key={appointment?._id}>
        <td>{index + 1}</td>
       
        
        <td>{appointment?.name || "N/A"}</td>
        <td>{appointment?.doctorId?.firstName || "N/A"}</td>
        <td>{appointment?.paymentMode || "Insurance"}</td>
        <td>{appointment?.status || "Pending"}</td>
        <td>
          {appointment?.date
            ? new Date(appointment?.date).toLocaleString("en-US", {
                dateStyle: "medium",
                timeStyle: "short",
              })
            : "N/A"}
        </td>
       
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
        No Appointments Found
      </td>
    </tr>
  )} 
</tbody>

      </table>
    </div>
  );
};

export default TodayAppointments;
